import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row text-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-1 d-md-none" }, null, -1)
const _hoisted_3 = { class: "col-9 col-md-10" }
const _hoisted_4 = { class: "col-2 text-start" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", {
  role: "link",
  class: "bi bi-search pointer"
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchBar',
  setup(__props) {

const searchText = ref("");

const search = () => {
    const searchInput = searchText.value.trim();
    const cleanedInput = searchInput.replace(/u\//g, "");
    
    if (searchInput.length > 0) {
        window.location.href = `/${cleanedInput}`;
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        class: "form-control rounded-0",
        type: "text",
        placeholder: "Enter public address or ENS",
        "aria-label": "Search",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
        onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (search()), ["enter"]))
      }, null, 544), [
        [_vModelText, searchText.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "mt-2",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (search()))
      }, _hoisted_6)
    ])
  ]))
}
}

})